export default __webpack_public_path__ + "static/media/NPI Logo.487fbe43.png";